import React, { useState, useEffect } from "react";
import { initKeycloak } from "./keycloakInit";
import {
  PROXY,
  ENDPOINT,
  addAuthInterceptor,
  logProxyConfiguration
} from "../helpers/authHelper";

const KeycloakApisixTest = () => {
  const [keycloak, setKeycloak] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [testResult, setTestResult] = useState(null);
  const [testLoading, setTestLoading] = useState(false);
  const [token, setToken] = useState(null);

  useEffect(() => {
    const initAuth = async () => {
      try {
        const kc = await initKeycloak();
        setKeycloak(kc);

        if (kc) {
          setIsAuthenticated(kc.authenticated);
          if (kc.authenticated) {
            setToken(kc.token);
            // Initialize proxy interceptors
            await addAuthInterceptor("https://opencity.idvilnius.lt", kc);
            logProxyConfiguration();
          }
        }
      } catch (err) {
        setError(err.message);
        console.error("Auth initialization error:", err);
      } finally {
        setLoading(false);
      }
    };

    initAuth();
  }, []);

  const handleLogin = async () => {
    if (keycloak) {
      try {
        await keycloak.login();
      } catch (err) {
        setError("Login failed: " + err.message);
        console.error("Login error:", err);
      }
    }
  };

  const testDirectArcgisCall = async () => {
    if (!token) {
      setTestResult({
        status: "error",
        message: "No token available",
      });
      return;
    }

    setTestLoading(true);
    setTestResult(null);

    try {
      // Test a simple ArcGIS REST API call through APISIX
      const testUrl = `https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/6`;

     //console.log("Testing direct ArcGIS call:", testUrl);

      const response = await fetch(
        `${testUrl}?f=json&token=${token}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      

      const data = await response.json();

      setTestResult({
        status: response.ok ? "success" : "error",
        message: response.ok
          ? "Direct ArcGIS call successful"
          : "Direct ArcGIS call failed",
        statusCode: response.status,
        data: data,
      });
    } catch (err) {
      setTestResult({
        status: "error",
        message: err.message,
      });
    } finally {
      setTestLoading(false);
    }
  };

  const testProxyApisixCall = async () => {
    if (!token) {
      setTestResult({
        status: "error",
        message: "No token available",
      });
      return;
    }

    setTestLoading(true);
    setTestResult(null);

    try {
      // Test through APISIX proxy
      const proxyUrl = `${PROXY}/${ENDPOINT}/?https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/6?f=json`;

     //console.log("Testing APISIX proxy call:", proxyUrl);

      const response = await fetch(proxyUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

     //console.log('Response headers:');
     //console.log('X-Debug-Token:', response.headers.get('X-Debug-Token'));
     //console.log('X-Debug-Response:', response.headers.get('X-Debug-Response'));

      const data = await response.json();

      setTestResult({
        status: response.ok ? "success" : "error",
        message: response.ok
          ? "APISIX proxy call successful"
          : "APISIX proxy call failed",
        statusCode: response.status,
        data: data,
      });
    } catch (err) {
      setTestResult({
        status: "error",
        message: err.message,
      });
    } finally {
      setTestLoading(false);
    }
  };

  if (loading) {
    return <div style={styles.container}>Loading authentication...</div>;
  }

  return (
    <div style={styles.container}>
      <h1>Keycloak + APISIX Test</h1>

      {error && <div style={styles.error}>Error: {error}</div>}

      {isAuthenticated ? (
        <div style={styles.testContainer}>
          <h2>Authenticated Successfully</h2>

          <div style={styles.tokenSection}>
            <h3>Token Info</h3>
            <p>
              <strong>Full Token:</strong>
            </p>
            <div style={styles.tokenBox}>
              <code style={{fontSize: "10px", wordBreak: "break-all"}}>{token}</code>
            </div>
            <button
              onClick={() => {
                if (keycloak?.idTokenParsed) {
                 //console.log("Decoded Token:", JSON.stringify(keycloak.idTokenParsed, null, 2));
                  alert("Check browser console (F12) for decoded token");
                }
              }}
              style={styles.infoButton}
            >
              Log Full Token to Console
            </button>
          </div>

          <div style={styles.configSection}>
            <h3>APISIX Configuration</h3>
            <p>
              <strong>Proxy:</strong> {PROXY}
            </p>
            <p>
              <strong>Endpoint:</strong> {ENDPOINT}
            </p>
            <p>
              <strong>Full Path:</strong> {PROXY}/{ENDPOINT}/
            </p>
            <button onClick={logProxyConfiguration} style={styles.infoButton}>
              Log Configuration to Console
            </button>
          </div>

          <div style={styles.testSection}>
            <h3>Test Requests</h3>

            <div style={styles.buttonGroup}>
              <button
                onClick={testProxyApisixCall}
                disabled={testLoading}
                style={styles.primaryButton}
              >
                {testLoading ? "Testing..." : "Test APISIX Proxy Call"}
              </button>

              <button
                onClick={testDirectArcgisCall}
                disabled={testLoading}
                style={styles.secondaryButton}
              >
                {testLoading ? "Testing..." : "Test Direct ArcGIS Call"}
              </button>
            </div>

            {testResult && (
              <div
                style={{
                  ...styles.resultBox,
                  borderColor:
                    testResult.status === "success" ? "#28a745" : "#dc3545",
                }}
              >
                <h4>
                  Test Result:{" "}
                  <span
                    style={{
                      color:
                        testResult.status === "success"
                          ? "#28a745"
                          : "#dc3545",
                    }}
                  >
                    {testResult.status.toUpperCase()}
                  </span>
                </h4>
                <p>
                  <strong>Message:</strong> {testResult.message}
                </p>
                {testResult.statusCode && (
                  <p>
                    <strong>Status Code:</strong> {testResult.statusCode}
                  </p>
                )}
                {testResult.data && (
                  <div>
                    <strong>Response Data:</strong>
                    <pre style={styles.responseData}>
                      {JSON.stringify(testResult.data, null, 2)}
                    </pre>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div style={styles.loginSection}>
          <p>Please login to test Keycloak + APISIX integration</p>
          <button onClick={handleLogin} style={styles.loginButton}>
            Login with Keycloak
          </button>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: "40px",
    maxWidth: "1000px",
    margin: "0 auto",
    fontFamily: "Arial, sans-serif",
  },
  error: {
    backgroundColor: "#f8d7da",
    color: "#721c24",
    padding: "12px",
    borderRadius: "4px",
    marginBottom: "20px",
    border: "1px solid #f5c6cb",
  },
  testContainer: {
    backgroundColor: "#f9f9f9",
    padding: "20px",
    borderRadius: "4px",
  },
  tokenSection: {
    backgroundColor: "white",
    padding: "15px",
    borderRadius: "4px",
    marginBottom: "20px",
    border: "1px solid #ddd",
  },
  tokenBox: {
    backgroundColor: "#f5f5f5",
    padding: "10px",
    borderRadius: "4px",
    overflow: "auto",
    marginTop: "10px",
  },
  configSection: {
    backgroundColor: "white",
    padding: "15px",
    borderRadius: "4px",
    marginBottom: "20px",
    border: "1px solid #ddd",
  },
  testSection: {
    backgroundColor: "white",
    padding: "15px",
    borderRadius: "4px",
    border: "1px solid #ddd",
  },
  buttonGroup: {
    display: "flex",
    gap: "10px",
    marginTop: "15px",
    marginBottom: "15px",
    flexWrap: "wrap",
  },
  primaryButton: {
    backgroundColor: "#007bff",
    color: "white",
    padding: "10px 20px",
    fontSize: "14px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
  secondaryButton: {
    backgroundColor: "#6c757d",
    color: "white",
    padding: "10px 20px",
    fontSize: "14px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
  infoButton: {
    backgroundColor: "#17a2b8",
    color: "white",
    padding: "8px 16px",
    fontSize: "12px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    marginTop: "10px",
  },
  resultBox: {
    backgroundColor: "#f9f9f9",
    padding: "15px",
    borderRadius: "4px",
    border: "2px solid #ddd",
    marginTop: "15px",
  },
  responseData: {
    backgroundColor: "#f5f5f5",
    padding: "10px",
    borderRadius: "4px",
    overflow: "auto",
    maxHeight: "400px",
    fontSize: "12px",
  },
  loginSection: {
    textAlign: "center",
    padding: "40px",
    backgroundColor: "white",
    borderRadius: "4px",
    border: "1px solid #ddd",
  },
  loginButton: {
    backgroundColor: "#28a745",
    color: "white",
    padding: "12px 24px",
    fontSize: "16px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    marginTop: "20px",
  },
};

export default KeycloakApisixTest;
